class TabNavigation {
  constructor() {

    if (document.querySelector('.facts-tabs'))  {
      this.initTabNavigation();
    }
  }

  initTabNavigation() {
    let buttons = document.querySelectorAll('.tabbar button');

    Array.from(buttons).forEach(button => {
      button.addEventListener('click', this.switchContent.bind(button, button));
    })
  }

  switchContent = button => {
    let tab = button.getAttribute('data-tab'),
      buttons = document.querySelectorAll('.tabbar button'),
      tabContent = document.querySelectorAll('.tabbar-content-element');

    Array.from(buttons).forEach(button => {
      button.classList.remove('active');
    })

    Array.from(tabContent).forEach(tabContentItem => {
      tabContentItem.style.display = 'none';
    })

    document.getElementById(tab).style.display = "block";
    button.classList.add('active');
  }
}

let tabNavigation = new TabNavigation();
